__turbopack_context__.v({
  "charSubhead": "howto-module__3rxVcW__charSubhead",
  "ctaBand": "howto-module__3rxVcW__ctaBand",
  "ctaBandSlim": "howto-module__3rxVcW__ctaBandSlim",
  "ctaHeadline": "howto-module__3rxVcW__ctaHeadline",
  "ctaSubtitle": "howto-module__3rxVcW__ctaSubtitle",
  "editorialList": "howto-module__3rxVcW__editorialList",
  "editorialListItem": "howto-module__3rxVcW__editorialListItem",
  "hairline": "howto-module__3rxVcW__hairline",
  "hero": "howto-module__3rxVcW__hero",
  "heroImageWrap": "howto-module__3rxVcW__heroImageWrap",
  "heroKicker": "howto-module__3rxVcW__heroKicker",
  "heroStat": "howto-module__3rxVcW__heroStat",
  "heroStatLabel": "howto-module__3rxVcW__heroStatLabel",
  "heroStatValue": "howto-module__3rxVcW__heroStatValue",
  "heroStats": "howto-module__3rxVcW__heroStats",
  "heroTagline": "howto-module__3rxVcW__heroTagline",
  "heroTitle": "howto-module__3rxVcW__heroTitle",
  "kicker": "howto-module__3rxVcW__kicker",
  "lede": "howto-module__3rxVcW__lede",
  "numberFigure": "howto-module__3rxVcW__numberFigure",
  "numberedItem": "howto-module__3rxVcW__numberedItem",
  "numberedItemMuted": "howto-module__3rxVcW__numberedItemMuted",
  "numberedItemText": "howto-module__3rxVcW__numberedItemText",
  "numberedList": "howto-module__3rxVcW__numberedList",
  "sectionTitle": "howto-module__3rxVcW__sectionTitle",
  "serif": "howto-module__3rxVcW__serif",
});
